import React from "react";
import Paper from '@mui/material/Paper';
import Dialog from '@mui/material/Dialog';
import DialogActions from "@mui/material/DialogActions";
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid2 from '@mui/material/Grid2';
import Button from '@mui/material/Button';
import Replay from "@mui/icons-material/Replay";
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import {getDecimal} from "../config/utils";
import {useSxStyles as sx} from "../styles/sxStyles";

const FeeList = (props) => {
    const fees = props.fees;
    const openFees = props.openFees;
    const setOpenFees = props.setOpenFees;

    return (
        (<Dialog
                disableEscapeKeyDown
                fullWidth
                maxWidth='md'
                open={openFees}
                onClose={() => setOpenFees(false)}
                sx={sx.dialog}
                aria-labelledby="View payment receipt"
            >
            <DialogTitle>
                <Typography variant="h6" component='h1' color='primary'>Non-Case Fees</Typography>
            </DialogTitle>
            <DialogContent dividers>
                <Paper elevation={3} sx={{...sx.tableContainer, padding: '1rem', overflow: 'auto'}}>
                    <List sx={sx.list} >
                        <ListItem alignItems="flex-start" sx={sx.listPadding}>
                            <ListItemText
                                sx={sx.listText}
                                primary={
                                    <Grid2
                                        container
                                        spacing={1}
                                        style={{width: '100%'}}
                                    >
                                        <Grid2
                                            size={{
                                                xs: 6,
                                                md: 3
                                            }}>Fee Name</Grid2>
                                        <Grid2
                                            sx={sx.valueRight}
                                            size={{
                                                xs: 6,
                                                md: 2
                                            }}>Amount</Grid2>
                                        <Grid2
                                            sx={sx.valueRight}
                                            size={{
                                                xs: 6,
                                                md: 2
                                            }}>Allow Amt. Entry</Grid2>
                                        <Grid2
                                            sx={sx.valueRight}
                                            size={{
                                                xs: 6,
                                                md: 5
                                            }}>Entry Instructions</Grid2>
                                    </Grid2>
                                }
                                slotProps={{
                                    primary: {
                                        component: 'span',
                                        variant: 'subtitle1',
                                        sx: sx.inline,
                                        color: 'primary'
                                    }
                                }}
                            />
                        </ListItem>
                        { fees && fees.map((fee) => {
                            return (<>
                                <ListItem alignItems="flex-start" divider sx={sx.listPadding}>
                                    <ListItemText
                                        sx={sx.listText}
                                        primary={
                                            <Grid2
                                                container
                                                spacing={1}
                                                style={{width: '100%'}}
                                            >
                                                <Grid2
                                                    size={{
                                                        xs: 6,
                                                        md: 3
                                                    }}>{fee.name}</Grid2>
                                                <Grid2
                                                    sx={sx.valueRight}
                                                    size={{
                                                        xs: 6,
                                                        md: 2
                                                    }}>{getDecimal(fee.amount)}</Grid2>
                                                <Grid2
                                                    sx={sx.valueRight}
                                                    size={{
                                                        xs: 6,
                                                        md: 2
                                                    }}>{fee.allowAmountEntry ? 'Yes' : 'No'}</Grid2>
                                                <Grid2
                                                    sx={sx.valueRight}
                                                    size={{
                                                        xs: 6,
                                                        md: 5
                                                    }}>{fee.entryInstructions}</Grid2>
                                            </Grid2>
                                        }
                                        slotProps={{
                                            primary: {
                                                component: 'span',
                                                variant: 'body2',
                                                sx: sx.inline,
                                                color: 'textPrimary'
                                            }
                                        }}
                                    />
                                </ListItem>
                            </>);
                        })}
                    </List>
                </Paper>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined"
                        color="primary"
                        startIcon={<Replay/>}
                        sx={sx.button}
                        onClick={() => setOpenFees(false)}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>)
    );
}

export default FeeList;
